import loaderComp from '../base-full-loader'

const loaderFull = {
  install (Vue, options) {
    this.EventBus = new Vue()
    Vue.component('loader', loaderComp)
    Vue.prototype.$loader = {
      show (params) {
        loaderFull.EventBus.$emit('show', params)
      },
      hide () {
        loaderFull.EventBus.$emit('hide')
      }
    }
  }
}

export default loaderFull
